import CollectionApi from 'client/api/v2/CollectionApi';

class RoleApi extends CollectionApi {
  /**
   * @description Set up the api for getting admin role information.
   */
  constructor() {
    super('/api/roles', {
      skip: 0,
      limit: 50,
    });
    this.baseUrl = '/api/roles';
  }
}

export default new RoleApi();
